import { render, staticRenderFns } from "./wxloginBindPhone.vue?vue&type=template&id=254643a8&scoped=true"
import script from "./wxloginBindPhone.vue?vue&type=script&lang=js"
export * from "./wxloginBindPhone.vue?vue&type=script&lang=js"
import style0 from "./wxloginBindPhone.vue?vue&type=style&index=0&id=254643a8&prod&lang=less&scoped=true"
import style1 from "./wxloginBindPhone.vue?vue&type=style&index=1&id=254643a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254643a8",
  null
  
)

export default component.exports